// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-count-wrapper {
  margin-bottom: 15px;
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(20px);
}

.card-count-wrapper.animated {
  opacity: 1;
  transform: translateY(0);
}

.card-count {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 12px;
  height: 100%;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.card-count:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
}

/* Background pattern */
.card-count::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.02;
  pointer-events: none;
  background-size: 20px 20px;
  background-position: 0 0, 10px 10px;
}

.card-count-primary::before {
  background-image: radial-gradient(#F79222 1px, transparent 1px);
}

.card-count-success::before {
  background-image: radial-gradient(#28a745 1px, transparent 1px);
}

.card-count-info::before {
  background-image: radial-gradient(#17a2b8 1px, transparent 1px);
}

/* Color variants */
.card-count-primary {
  border-bottom: 3px solid #F79222;
}

.card-count-success {
  border-bottom: 3px solid #28a745;
}

.card-count-info {
  border-bottom: 3px solid #17a2b8;
}

.card-count-content {
  position: relative;
  z-index: 1;
}

.card-count-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.card-count-icon-wrapper {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.card-count-icon-primary {
  background-color: rgba(247, 146, 34, 0.1);
  color: #F79222;
}

.card-count-icon-success {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.card-count-icon-info {
  background-color: rgba(23, 162, 184, 0.1);
  color: #17a2b8;
}

.card-count-trend {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 6px;
  border-radius: 12px;
  transition: transform 0.2s ease;
}

.card-count:hover .card-count-trend {
  transform: scale(1.1);
}

.card-count-trend.positive {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.card-count-trend.negative {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.card-count-trend i {
  margin-right: 2px;
  font-size: 9px;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  position: relative;
  top: -1px; /* Fine-tune vertical alignment */
}

.card-count-details {
  margin-bottom: 8px;
}

.card-count-value {
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 2px 0;
  color: #333;
  transition: all 0.3s ease;
  transform-origin: left;
  line-height: 1.1;
}

.card-count:hover .card-count-value {
  transform: scale(1.05);
}

.card-count-title {
  font-size: 12px;
  font-weight: 500;
  color: #6c757d;
  margin: 0;
}

.card-count-view-details {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 10px;
  font-weight: 600;
  color: #6c757d;
  transition: color 0.2s ease;
  border-top: 1px solid #f0f0f0;
  padding-top: 6px;
  margin-top: 6px;
}

.card-count:hover .card-count-view-details {
  color: #F79222;
}

.card-count-view-details i {
  margin-left: 3px;
  font-size: 8px;
  transition: transform 0.2s ease;
}

.card-count:hover .card-count-view-details i {
  transform: translateX(3px);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .card-count {
    padding: 10px;
  }
  
  .card-count-icon-wrapper {
    width: 28px;
    height: 28px;
    font-size: 14px;
  }
  
  .card-count-value {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App/components/CardCount/styles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,+DAA+D;AACjE;;AAEA,mBAAmB;AACnB;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS,EAAE,iCAAiC;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".card-count-wrapper {\n  margin-bottom: 15px;\n  transition: all 0.3s ease;\n  opacity: 0;\n  transform: translateY(20px);\n}\n\n.card-count-wrapper.animated {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.card-count {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  padding: 12px;\n  height: 100%;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.card-count:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);\n}\n\n/* Background pattern */\n.card-count::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 0.02;\n  pointer-events: none;\n  background-size: 20px 20px;\n  background-position: 0 0, 10px 10px;\n}\n\n.card-count-primary::before {\n  background-image: radial-gradient(#F79222 1px, transparent 1px);\n}\n\n.card-count-success::before {\n  background-image: radial-gradient(#28a745 1px, transparent 1px);\n}\n\n.card-count-info::before {\n  background-image: radial-gradient(#17a2b8 1px, transparent 1px);\n}\n\n/* Color variants */\n.card-count-primary {\n  border-bottom: 3px solid #F79222;\n}\n\n.card-count-success {\n  border-bottom: 3px solid #28a745;\n}\n\n.card-count-info {\n  border-bottom: 3px solid #17a2b8;\n}\n\n.card-count-content {\n  position: relative;\n  z-index: 1;\n}\n\n.card-count-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.card-count-icon-wrapper {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  font-size: 16px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.card-count-icon-primary {\n  background-color: rgba(247, 146, 34, 0.1);\n  color: #F79222;\n}\n\n.card-count-icon-success {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n.card-count-icon-info {\n  background-color: rgba(23, 162, 184, 0.1);\n  color: #17a2b8;\n}\n\n.card-count-trend {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 6px;\n  border-radius: 12px;\n  transition: transform 0.2s ease;\n}\n\n.card-count:hover .card-count-trend {\n  transform: scale(1.1);\n}\n\n.card-count-trend.positive {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n.card-count-trend.negative {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n.card-count-trend i {\n  margin-right: 2px;\n  font-size: 9px;\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n  position: relative;\n  top: -1px; /* Fine-tune vertical alignment */\n}\n\n.card-count-details {\n  margin-bottom: 8px;\n}\n\n.card-count-value {\n  font-size: 24px;\n  font-weight: 700;\n  margin: 0 0 2px 0;\n  color: #333;\n  transition: all 0.3s ease;\n  transform-origin: left;\n  line-height: 1.1;\n}\n\n.card-count:hover .card-count-value {\n  transform: scale(1.05);\n}\n\n.card-count-title {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6c757d;\n  margin: 0;\n}\n\n.card-count-view-details {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  font-size: 10px;\n  font-weight: 600;\n  color: #6c757d;\n  transition: color 0.2s ease;\n  border-top: 1px solid #f0f0f0;\n  padding-top: 6px;\n  margin-top: 6px;\n}\n\n.card-count:hover .card-count-view-details {\n  color: #F79222;\n}\n\n.card-count-view-details i {\n  margin-left: 3px;\n  font-size: 8px;\n  transition: transform 0.2s ease;\n}\n\n.card-count:hover .card-count-view-details i {\n  transform: translateX(3px);\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .card-count {\n    padding: 10px;\n  }\n  \n  .card-count-icon-wrapper {\n    width: 28px;\n    height: 28px;\n    font-size: 14px;\n  }\n  \n  .card-count-value {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
